// extracted by mini-css-extract-plugin
export default {"hatv_main_container":"HatvComponent_hatv_main_container__pIZ2F","hatv_outer_container":"HatvComponent_hatv_outer_container__bKXtl","landing_page":"HatvComponent_landing_page__Tx2gE"};